import axios, { AxiosInstance } from "axios";
import { getEnv } from "../utils";
export class AmplifilesClient {
  private static _instance: AxiosInstance;

  static get instance() {
    if (!this._instance) {
      this._instance = this.createClient();

      this._instance.interceptors.request.use(async (config) => {
        const clerk = window.Clerk;

        const token = clerk ? await clerk.session.getToken() : null;

        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }

        return config;
      });
    }

    return this._instance;
  }

  private static createClient() {
    return axios.create({
      baseURL: getEnv("VITE_BACKEND_URL"),
      timeout: 60_000,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  static async stream(
    url: string,
    options: RequestInit = {},
  ): Promise<Response> {
    const baseURL = getEnv("VITE_BACKEND_URL");
    const clerk = window.Clerk;
    const token = clerk ? await clerk.session?.getToken() : null;

    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      ...(options.headers as Record<string, string>),
    };

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(`${baseURL}${url}`, {
      ...options,
      headers,
    });

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status}`);
    }

    return response;
  }
}
